import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";
import AddHtml from '@/pages/trainCodeRule/addHtml.vue';

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const handleDetete = listeners["handleDetete"] || function () { };
  const fixCredit = listeners["fixCredit"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          handleDetete(item);
        },
        "liveRoomUser:delete",
      ]
    ];
    if (item.credit == 0) {
      dealConf.push([
        "icon-edit",
        "学分修复",
        () => {
          fixCredit(item);
        },
        "liveRoomUser:repair",
      ])
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const StatusName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <AddHtml html={item.pushStatusName} />
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "m100", true),
    tableBaseProps("工作单位", "deptName", "m150", true),
    tableBaseProps("单位及职务", "unitPosition", "m150", true),
    tableBaseProps("直播观看时长", "visitTimeStr", "m80"),
    tableBaseProps("直播学分", "credit", "m80"),
    // tableBaseProps("回放观看时长", "playbackTime", "100"),
    tableBaseProps("回放学分", "playbackCredit", "m80"),
    tableBaseProps("浙政钉绑定状态", "bindStatusName", "m90"),
    {
      ...tableBaseProps("干部之家同步状态", "unitPosition", "m100"),
      render: (vo) => <StatusName vo={vo} />,
    }, {
      label: "添加方式",
      prop: "fromTypeStr",
      minWidth: "m80",
    }, {
      label: "操作",
      fixed: "right",
      minWidth: 40,
      render: (vo) => <Deal vo={vo} />,
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
